import React, { useState, useEffect } from "react";
import { getBNVaults } from "../../../networking/NetworkingOrders";
import { getStyle } from "../../../styles/styles";
import MultipleSelect from "../../shared/MultipleSelect";
import VaultBalanceNotationsGrid from "./VaultBalanceNotationsGrid";
import { useVaultBalanceData } from "./useVaultBalanceData";

const style = getStyle();

const VaultBalanceScreen = () => {
  const [vaults, setVaults] = useState([])
  const [selectedVaults, setSelectedVaults] = useState([])

  const vaultId = selectedVaults.length > 0 ? selectedVaults[0].VaultId : null;
  const { columnsData, columnDetail, refresh } = useVaultBalanceData(vaultId);

  const fetchVaultsList = async () => {
    const response = await getBNVaults();
    if (response && response.response && response.response.data) {
      const vaultData = response.response.data.map(vault => ({
        VaultId: vault.VaultID,
        Description: vault.Description
      }));
      setVaults(vaultData);
    } else if (response && response.data) {
      const vaultData = response.data.map(vault => ({
        VaultId: vault.VaultID,
        Description: vault.Description
      }));
      setVaults(vaultData);
    } else {
      setVaults([]);
    }
  };

  useEffect(() => {
    fetchVaultsList();
  }, []);

  const onVaultsChange = (value) => {
    setSelectedVaults(value);
  }

  return (
    <div>
      <h3 className="uk-heading-divider" style={style.titleStyle}>
        Vault Balance
      </h3>
      <div>
        <form className="uk-form-stacked uk-grid">
          <div className="uk-width-4-12" >
            <div className="uk-margin">
              <label className="uk-form-label" htmlFor="form-bank-name">Vault Selection</label>
              <div className="uk-form-controls">
                <MultipleSelect data={vaults} textField='Description' valueField='VaultId' onChange={onVaultsChange} />
              </div>
            </div>
          </div>
          <div className="uk-width-2-12">
            <div className="uk-margin">
              <button className="uk-button uk-button-green" style={{ marginTop: '20px' }} type="button" onClick={refresh}>Refresh Data</button>
            </div>
          </div>
        </form>
        <br />
        {Array.isArray(columnsData) && columnsData.length > 0 ? (
          <VaultBalanceNotationsGrid columnsData={columnsData} columnDetail={columnDetail} />
        ) : (
          <div style={{ textAlign: 'center', marginTop: '40px', color: '#888' }}>No data to display</div>
        )}
      </div>
    </div>
  );
};

export default VaultBalanceScreen;